export default __webpack_public_path__ + "static/media/newsIcon.411f6762.webp";